@if (!error) {
  <rt-select
    [formControl]="input.control"
    [options]="resourceSelectOptions"
    [hasSearch]="showSearch()"
    [placeholder]="selectPlaceholder"
    [includeEmptyOption]="input.includeEmptyOption"
    [multiple]="input.multiple"
    [closeOnSelect]="!input.multiple"
  />

  @if (showSpinner) {
    <rt-spinner variant="small" />
  }
}

@if (error && loading) {
  <rt-select
    [formControl]="input.control"
    [options]="[]"
    [hasSearch]="false"
    [placeholder]="selectPlaceholder"
    [includeEmptyOption]="false"
  />
}

@if (error && !loading) {
  {{ error }}
}
